import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';


export interface PropertyElement {
  id: string;
  address: number;
  owner: number;
  status: string;
}

const ELEMENT_DATA: PropertyElement[] = [
 
];

@Component({
  selector: 'app-propertylist',
  templateUrl: './propertylist.component.html',
  styleUrl: './propertylist.component.css'
})
export class PropertylistComponent {
  displayedColumns: string[] = ['id', 'address', 'owner', 'status'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
